import { Component, OnInit, EventEmitter, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FormFieldConfig } from "../../models/form-field-config";
import { BehaviorSubject } from "rxjs";
import * as _ from "lodash";
import { IFormField } from "../../interfaces/iform-field";
import { Filter } from "../../models/filter";
import { MatSelect } from "@angular/material/select";
import { FieldError } from "../../models/field-error";
import { FormUtils } from "../../form-utils";

@Component({
    selector: "wtf-form-select",
    templateUrl: "./form-select.component.html",
    styleUrls: ["./form-select.component.scss"],
})
export class FormSelectComponent implements OnInit, IFormField {
    @ViewChild("select") selectControl: MatSelect;

    propertyName: string;
    optionsBehavior = new BehaviorSubject<any>([]);
    options = this.optionsBehavior.asObservable();
    rawListOptions: Array<any>;
    errors = new Array<FieldError>();

    group: FormGroup;
    config: FormFieldConfig;

    idPropertyName: string;
    valuePropertyName: string;
    optionSelected: any;

    selectionExecuted = false;
    isVisible = true;
    inline = false;

    constructor() {}

    ngOnInit() {
        this.getOptions();

        if (this.config) {
            this.propertyName = this.config.fieldInfo.name;
            this.inline = this.config.fieldInfo.inline;
        }
    }

    getOptions() {
        if (this.config.options) {
            this.idPropertyName = this.config.options.idPropertyName;
            this.valuePropertyName = this.config.options.valuePropertyName;

            if (this.config.options.fixedOptions) {
                this.rawListOptions = this.config.options.fixedOptions;
                this.optionsBehavior.next(this.rawListOptions);

                this.setDefaultOption();
            }
        }
    }

    setDefaultOption() {
        if (this.config.fieldInfo.defaultValue && this.rawListOptions) {
            this.rawListOptions.forEach((item) => {
                if (
                    item[this.idPropertyName] ===
                    this.config.fieldInfo.defaultValue
                ) {
                    this.optionSelected = item[this.idPropertyName];
                }
            });
        }
    }

    setObservableDataSource(data: any) {
        if (!data) {
            return;
        }

        const self = this;
        data.subscribe((res) => {
            self.rawListOptions = res;
            self.optionsBehavior.next(res);
        });
    }

    getErrorList() {
        const control = this.group.controls[this.config.fieldInfo.name];
        this.errors.length = 0;

        if (control.errors) {
            this.errors = FormUtils.getErrorRepresentation(control.errors);
        }

        return this.errors;
    }

    onFocus(event) {
        if (this.errors) {
            this.errors.length = 0;
        }
    }

    onLostFocus(event) {
        this.getErrorList();
    }

    setVisible(isVisible: boolean) {
        this.isVisible = isVisible;
    }

    isControlVisible(): boolean {
        return this.isVisible;
    }
}
